import React from "react";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function CreateRequest({
  closeModal,
  alert,
  requestType,
  getAllRequest,
  officeRequestsCategories,
  individualRequestsCategories,
}) {
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          request_type: "",
          description: "",
          price: "",
          request_category: "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          ApiService.post("requests/create-request", values).then((res) => {
            console.log("res", res)
            if (res.data.type === false) {
              alert.error(res.data.msg);
              closeModal();
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
              closeModal();
            }
            getAllRequest();
            closeModal();
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="form-group">
              <label>
                Request Type <span className="text-danger"> * </span>
              </label>
              <Field
                name="request_type"
                as="select"
                className="form-control select2 required"
              >
                <option>--Select Request Type--</option>
                {requestType.map((request, i) => (
                  <option value={request.id} key={i}>
                    {request.name}
                  </option>
                ))}
              </Field>
            </div>
            {values.request_type !== "" ? (
              <div className="form-group">
                <label>
                  {values.request_type === "2"
                    ? "Sub Office Categories"
                    : "Sub Individual Categories"}{" "}
                  <span className="text-danger"> * </span>
                </label>
                <Field
                  name="request_category"
                  as="select"
                  className="form-control select2 required"
                >
                  <option>--Select subcategory--</option>
                  {values.request_type === "2"
                    ? officeRequestsCategories.map((request, i) => (
                      <option value={request.id} key={i}>
                        {request.name}
                      </option>
                    ))
                    : individualRequestsCategories.map((request, i) => (
                      <option value={request.id} key={i}>
                        {request.name}
                      </option>
                    ))}
                </Field>
              </div>
            ) : null}

            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Description <span className="text-danger"> * </span>
                  </label>
                  <Field
                    name="description"
                    as="textarea"
                    required="required"
                    cols="10"
                    rows="5"
                    className="form-control"
                  ></Field>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Price <span className="text-danger"> * </span>
                  </label>
                  <Field
                    type="number"
                    className="form-control"
                    name="price"
                    required="required"
                  />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/request/modal/create_request.js